import { ActivityType } from '../enums/ActivityType'

/**
 * Which activity types are a played game. Three backend helpers each kept their own copy of this set,
 * which is one edit away from disagreeing about what a "game" is; they all read this one now.
 */
export const GAME_ACTIVITY_TYPES = new Set<ActivityType>([
  ActivityType.FIRST_GAME,
  ActivityType.SHORT_GAME,
  ActivityType.LONG_GAME
])

export const isGameActivityType = (activityType: string | ActivityType | undefined): boolean =>
  !!activityType && GAME_ACTIVITY_TYPES.has(activityType as ActivityType)

/** The reflections that follow a game: the AI debrief and the group reflection, which people lead. */
const REFLECTION_ACTIVITY_TYPES = new Set<ActivityType>([ActivityType.SHORT_REFLECTION, ActivityType.LONG_REFLECTION])

export const isReflectionActivityType = (activityType: string | ActivityType | undefined): boolean =>
  !!activityType && REFLECTION_ACTIVITY_TYPES.has(activityType as ActivityType)

/** Returns true if the activity type is an AI debrief (short reflection only). */
export const isAIDebriefActivity = (activityType: string | ActivityType | undefined): boolean =>
  activityType === ActivityType.SHORT_REFLECTION

/** A game's AI debrief: the first reflection after the game, when that reflection is an AI debrief. */
export const findAIDebriefAfterGame = <Activity extends { type?: string | ActivityType }>(
  activities: Activity[],
  gameIndex: number
): Activity | undefined => {
  const reflection = activities.slice(gameIndex + 1).find((activity) => isReflectionActivityType(activity.type))
  return isAIDebriefActivity(reflection?.type) ? reflection : undefined
}
